import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store';
import { CircularProgress, Box } from '@mui/material';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, shouldSeeAdminPanel, authInitialized } = useAuthStore();

  // Wait for Firebase authentication to initialize
  if (!authInitialized) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/?message=Musisz być zalogowany aby uzyskać dostęp" replace />;
  }

  if (requireAdmin && !shouldSeeAdminPanel) {
    return <Navigate to="/?message=Brak uprawnień do panelu administracyjnego" replace />;
  }

  return children;
};

export default ProtectedRoute;
